// ============================================================================
// CONFIG ENDPOINTS
// ============================================================================
// API endpoint definitions for Configuration Framework module

import { buildEndpoint, buildEndpointWithQuery } from './base.endpoints';

const BASE_PATH = '/Config';

export const configEndpoints = {
  /** GET /Config/groups — get all config groups */
  groups: () => buildEndpoint(`${BASE_PATH}/groups`),

  /** GET /Config/modules — module switches and where each is on */
  modules: () => buildEndpoint(`${BASE_PATH}/modules`),

  /** GET /Config/definitions?group={group} — get definitions for a group */
  definitions: (group: string) =>
    buildEndpointWithQuery(`${BASE_PATH}/definitions`, { group }),

  /** GET /Config/effective?group={group}&scopes={scopes} — get effective values with scope resolution */
  effective: (group: string, scopes?: string) =>
    buildEndpointWithQuery(`${BASE_PATH}/effective`, { group, scopes }),

  /** GET /Config/effective/{configKey}?scopes={scopes} — get single effective value */
  effectiveByKey: (configKey: string, scopes?: string) =>
    buildEndpointWithQuery(`${BASE_PATH}/effective/${configKey}`, { scopes }),

  /** PUT /Config/values — update config overrides at a specific scope */
  updateValues: () => buildEndpoint(`${BASE_PATH}/values`),

  /** GET /Config/scopes?scopeType={type} — list scope entries by type */
  scopes: (scopeType: string) =>
    buildEndpointWithQuery(`${BASE_PATH}/scopes`, { scopeType }),
};

export default configEndpoints;
